import { useNavigate } from "react-router-dom";

import styles from "../../assets/css/pane.module.scss";

const RemittanceHomeRightPane = ({ children }) => {
  // const navigate = useNavigate();

  // const handleLogin = () => {
  //   navigate("/login", { replace: true });
  // };

  // const handleSignUp = () => {
  //   navigate("/signup?source=remittance", { replace: true });
  // };

  return (
    <div className={styles.rightPane}>
      <div className={`${styles.btnConatiner} ${styles.btnConatinerHome}`}>
        <div className={styles.goToContainer}>
          {/* <div className={styles.loginBtn} onClick={handleLogin}>
            Login
          </div>
          <div className={styles.logoutbtn} onClick={handleSignUp}>
            Signup
          </div> */}
        </div>
      </div>
      <div className={styles.mainContainer}>{children}</div>
    </div>
  );
};
export default RemittanceHomeRightPane;
